import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  quote: string;
  transformation: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote,
  transformation
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300 flex flex-col h-full" data-id="element-9">
      <div className="mb-4" data-id="element-10">
        <Quote className="w-8 h-8 text-blue-200 fill-blue-50" data-id="element-11" />
      </div>

      <div className="mb-6 flex-grow" data-id="element-12">
        <p className="text-gray-700 italic mb-4 text-lg" data-id="element-13">"{quote}"</p>
        <div className="bg-blue-50 p-3 rounded-lg border-l-4 border-blue-500" data-id="element-14">
          <p className="text-sm text-blue-900 font-medium" data-id="element-15">
            <span className="font-bold" data-id="element-16">Resultado:</span> {transformation}
          </p>
        </div>
      </div>

      <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-17">
        <p className="font-bold text-gray-900" data-id="element-18">{name}</p>
        <p className="text-sm text-gray-600" data-id="element-19">{role}</p>
        <p className="text-xs text-gray-400 mt-1" data-id="element-20">{location}</p>
      </div>
    </div>;
}